import { gsap } from "gsap"

/**
 * CREATORセクションの「View more...」制御
 * グループごとに初期6件だけ表示し、クリックで残りをふわっと開く。
 */

/** 動きを減らす設定のユーザーには即時表示にする */
const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

/**
 * 1グループのVIEW MOREを初期化する
 * @param {HTMLElement} group - [data-creator-group] を持つグループ要素
 */
const initGroup = (group: HTMLElement): void => {
  const btn = group.querySelector<HTMLButtonElement>("[data-creator-more]")
  if (!btn) return

  btn.addEventListener("click", () => {
    const cards = [...group.querySelectorAll<HTMLElement>(".Cardcreator[hidden]")]

    cards.forEach((card) => {
      card.removeAttribute("hidden")
      card.classList.remove("is-hidden")
    })

    group.classList.add("is-expanded")
    btn.setAttribute("aria-expanded", "true")

    if (reduceMotion || !cards.length) return

    // 下から順にふわっと現す
    gsap.from(cards, {
      y: 32,
      autoAlpha: 0,
      duration: 0.6,
      stagger: 0.07,
      ease: "power2.out",
    })
  })
}

document.querySelectorAll<HTMLElement>("[data-creator-group]").forEach(initGroup)
